import { parseInvitationTasks } from './invitationTasks.js';
import { formatDecimal } from './formatDecimal.js';

// 只展示当前后台开启的奖励；注册奖励属于被邀请人，任务奖励属于邀请人。
export function buildInvitationRewardRules(rawRules) {
  let rules = rawRules;
  if (typeof rules === 'string') {
    try { rules = JSON.parse(rules); } catch { return []; }
  }
  if (!rules || typeof rules !== 'object') return [];
  const result = [];
  if (Array.isArray(rules.rewardTiers) && Number(rules.enabled) === 1) {
    for (const [index, tier] of rules.rewardTiers.entries()) {
      const amount = String(tier.firstDepositAmount), reward = String(tier.bonusAmount);
      if (!/^\d+(?:\.\d{1,2})?$/.test(amount) || !/^\d+(?:\.\d{1,2})?$/.test(reward) || Number(reward) <= 0) continue;
      result.push({ type: `first-deposit-${index}`, title: '好友首存奖励', condition: `好友首笔成功到账存款达到 ${formatDecimal(amount)} 元`, result: `邀请人奖励 ${formatDecimal(reward)} 元，达标和到账以活动记录为准` });
    }
    return result;
  }
  if (Number(rules.enabled) === 1 && Number(rules.inviteeRewardEnabled) === 1 && /^\d+(?:\.\d{1,2})?$/.test(String(rules.inviteeRewardAmount)) && Number(rules.inviteeRewardAmount) > 0) {
    result.push({
      type: 'register',
      title: '好友注册奖励',
      condition: '好友完成注册并通过实名认证',
      result: `向好友的中心钱包发放 ${formatDecimal(rules.inviteeRewardAmount)} 元`
    });
  }
  for (const task of parseInvitationTasks(rules)) {
    const conditions = task.details.slice(0, -1);
    if (task.type === 'bet') {
      conditions.push(...task.venues.map(venue => `${venue.name}：${venue.rate}`));
      conditions.push(`最低返利：${task.minimumThreshold}；每位好友累计上限：${task.maximumReward}`);
      conditions.push(task.thresholdHint);
    }
    result.push({
      type: task.type,
      title: task.title,
      condition: conditions.join('；'),
      result: task.details.at(-1)
    });
  }
  return result;
}

export const INVITATION_REWARD_NOTES = [
  '注册奖励发放至被邀请人的中心钱包；充值和投注任务奖励发放至邀请人的中心钱包。',
  '仅展示当前开启的奖励，参与条件与奖励额度以活动配置和实际达标记录为准。',
  '同一实名身份不会重复获得同一笔奖励；投注返利按每位好友的累计上限计算。'
];
